import styled from 'styled-components'

export const Container = styled.div`
	position: fixed;
	top: 0;
	left: 0;
	z-index: 9999;

	height: 100%;
	width: 100%;

	background: white;

	display: grid;
	place-items: center;
`

export const Image = styled.img`
	width: 250px;
`
